var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{staticStyle:{"padding":"5px"},attrs:{"visible":_vm.dialogVisible,"append-to-body":"","title":"文件预览","top":"0vh","width":"80%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('pdf-viewer-v2',{ref:"pdfViewer",attrs:{"pdf-url":_vm.pdfUrl}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }